module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-navy-5-bb81dfab2eaaabfec426447ebbe1a224.webp";